import { BundleResourcesPackage } from "resource-system";
import { Texture } from "@pixi/core";
export class LoseSceneResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("LoseSceneResourcesPackage");
    }
    public get assets_lose_background_green_png(): Texture {
        return this.resource<Texture>("assets/lose/background_green.png");
    }
    public get assets_lose_background_green_mobile_png(): Texture {
        return this.resource<Texture>("assets/lose/background_green_mobile.png");
    }
    public get assets_lose_background_pink_png(): Texture {
        return this.resource<Texture>("assets/lose/background_pink.png");
    }
    public get assets_lose_background_pink_mobile_png(): Texture {
        return this.resource<Texture>("assets/lose/background_pink_mobile.png");
    }
    public get assets_lose_effects_particles_dot_1_png(): Texture {
        return this.resource<Texture>("assets/lose/effects/particles/dot_1.png");
    }
    public get assets_lose_effects_particles_dot_2_png(): Texture {
        return this.resource<Texture>("assets/lose/effects/particles/dot_2.png");
    }
    public get assets_lose_effects_particles_dot_3_png(): Texture {
        return this.resource<Texture>("assets/lose/effects/particles/dot_3.png");
    }
    public get assets_lose_effects_particles_emitter_json(): Object {
        return this.resource<Object>("assets/lose/effects/particles/emitter.json");
    }
    public get assets_lose_effects_win_glow_win_glow_atlas(): any {
        return this.resource<any>("assets/lose/effects/win_glow/win_glow.atlas");
    }
    public get assets_lose_effects_win_glow_win_glow_json(): Object {
        return this.resource<Object>("assets/lose/effects/win_glow/win_glow.json");
    }
    public get assets_lose_effects_win_glow_win_glow_png(): Texture {
        return this.resource<Texture>("assets/lose/effects/win_glow/win_glow.png");
    }
}

